// @ts-check
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Junta classes condicionais e resolve conflitos do Tailwind
 * (`px-2 px-4` vira `px-4`).
 * @param {...any} inputs
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
